module.exports = __webpack_public_path__ + "media/src/images/partners/open_education-dc439de954cea338e20d05d7c02f9a83.jpg";